export default "__VITE_ASSET__C7jve1ib__"